import * as React from 'react';
import { Inbox } from 'lucide-react';
import { cn } from '../../utils/cn';

const EmptyState = React.forwardRef(({ className, ...props }, ref) => (
    <div
        ref={ref}
        className={cn('flex flex-col items-center w-full', className)}
        {...props}
    />
));
EmptyState.displayName = 'EmptyState';

const EmptyStateContent = React.forwardRef(({ className, ...props }, ref) => (
    <div
        ref={ref}
        className={cn(
            'bg-card border border-dashed border-border rounded-lg p-6 w-full flex flex-col items-center gap-6',
            className,
        )}
        {...props}
    />
));
EmptyStateContent.displayName = 'EmptyStateContent';

const EmptyStateIcon = React.forwardRef(
    ({ className, children, ...props }, ref) => (
        <div
            ref={ref}
            className={cn(
                'bg-card border border-border rounded-md p-2 w-12 h-12 flex items-center justify-center',
                className,
            )}
            {...props}
        >
            {children || <Inbox className="h-6 w-6 text-foreground" />}
        </div>
    ),
);
EmptyStateIcon.displayName = 'EmptyStateIcon';

const EmptyStateTitle = React.forwardRef(({ className, ...props }, ref) => (
    // TODO: Change to h3 once global styles are removed from main.scss
    <div
        ref={ref}
        className={cn(
            'text-xl font-semibold text-foreground text-center',
            className,
        )}
        {...props}
    />
));
EmptyStateTitle.displayName = 'EmptyStateTitle';

const EmptyStateDescription = React.forwardRef(
    ({ className, ...props }, ref) => (
        // TODO: Change to p once global styles are removed from main.scss
        <div
            ref={ref}
            className={cn(
                'text-sm text-muted-foreground text-center',
                className,
            )}
            {...props}
        />
    ),
);
EmptyStateDescription.displayName = 'EmptyStateDescription';

const EmptyStateActions = React.forwardRef(({ className, ...props }, ref) => (
    <div
        ref={ref}
        className={cn('flex items-center justify-center gap-3', className)}
        {...props}
    />
));
EmptyStateActions.displayName = 'EmptyStateActions';

export {
    EmptyState,
    EmptyStateContent,
    EmptyStateIcon,
    EmptyStateTitle,
    EmptyStateDescription,
    EmptyStateActions,
};
